import React, { FC, ChangeEvent } from "react";
import clsx from "clsx";

import styles from "./SelectField.module.scss";

type Props = {
  id: string;
  label: string;
  value: string;
  options: string[];
  placeholder: string;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
};

const SelectField: FC<Props> = ({
  id,
  label,
  value,
  options,
  placeholder,
  onChange,
}) => {
  return (
    <div className={styles.field}>
      <label className={styles.label}>{label}</label>
      <div className={styles.selectWrapper}>
        <select
          className={clsx(styles.select, value === "" && styles.placeholder)}
          id={id}
          value={value}
          onChange={onChange}
        >
          <option value="" disabled hidden>
            {placeholder}
          </option>
          <option value="" />
          {options.map(option => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default SelectField;
